import NamedDto from 'modules/base/dto/NamedDto';

export class LummusModelComponentEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.value = null;
	}

	/**
	 * @typedef {Object} _LummusModelComponentEditDtoProps
	 * @property {number} value
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _LummusModelComponentEditDtoProps} LummusModelComponentEditDtoProps
	 */
	/**
	 *
	 * @param {LummusModelComponentEditDtoProps} props
	 * @returns {LummusModelComponentEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.value = props.value;
		return this;
	}
}

export default LummusModelComponentEditDto;
